import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CarouselCard } from '../../../../models/carousel-card.model';

@Component({
  selector: 'mom-vertical-carousel',
  templateUrl: './vertical-carousel.component.html',
  styleUrls: ['./vertical-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalCarouselComponent {
  @Input() cards: CarouselCard[];
  @Output() continue = new EventEmitter<CarouselCard>();
}
